// Legal & informational content for French Curl Vibes
import { BRAND } from "@/data/product";

export const LEGAL_PAGES = {
  mentions: {
    slug: "mentions-legales",
    title: "Mentions légales",
    intro: "Informations légales relatives au site French Curl Vibes.",
    sections: [
      {
        heading: "Éditeur du site",
        body: [
          `Le présent site est édité par la société ${BRAND.legalName}, SASU au capital social de [à compléter].`,
          `Siège social : ${BRAND.address}.`,
          "Présidente : Madame Anita Ndaywel.",
          `SIREN : ${BRAND.siren}.`,
          `TVA intracommunautaire : ${BRAND.vat}.`,
          `Adresse e-mail : ${BRAND.email}.`,
          "Activité : Vente en ligne de mèches French Curl et accessoires capillaires.",
        ],
      },
      {
        heading: "Hébergement",
        body: [
          "Le site est hébergé par : [Nom de l'hébergeur à compléter], [Adresse de l'hébergeur à compléter].",
        ],
      },
      {
        heading: "Propriété intellectuelle",
        body: [
          "L'ensemble des éléments présents sur le site (textes, images, logos, graphismes, vidéos, marques, etc.) est protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation, modification ou exploitation sans autorisation préalable écrite est interdite.",
        ],
      },
      {
        heading: "Responsabilité",
        body: [
          `${BRAND.legalName} s'efforce d'assurer l'exactitude des informations diffusées sur le site. Toutefois, elle ne saurait être tenue responsable des erreurs, omissions ou indisponibilités temporaires du service.`,
        ],
      },
    ],
  },

  confidentialite: {
    slug: "confidentialite",
    title: "Politique de confidentialité",
    intro: "Conformément au RGPD, voici la manière dont nous traitons vos données.",
    sections: [
      {
        heading: "1. Responsable du traitement",
        body: [
          `La société ${BRAND.legalName} est responsable du traitement des données personnelles collectées sur le site French Curl Vibes.`,
          `Contact : ${BRAND.email}.`,
        ],
      },
      {
        heading: "2. Données collectées",
        list: [
          "Nom et prénom",
          "Adresse postale",
          "Adresse e-mail",
          "Numéro de téléphone",
          "Informations de commande",
          "Historique d'achats",
          "Données de navigation et cookies",
        ],
      },
      {
        heading: "3. Finalités du traitement",
        list: [
          "Traiter les commandes",
          "Assurer la livraison",
          "Répondre aux demandes des clients",
          "Envoyer des informations commerciales (avec consentement)",
          "Améliorer l'expérience utilisateur",
          "Respecter nos obligations légales",
        ],
      },
      {
        heading: "4. Base légale",
        list: [
          "L'exécution du contrat de vente",
          "Le consentement de l'utilisateur",
          "Les obligations légales applicables",
          "L'intérêt légitime de l'entreprise",
        ],
      },
      {
        heading: "5. Conservation des données",
        body: [
          "Les données sont conservées pendant la durée nécessaire à leur traitement et conformément aux obligations légales françaises et européennes.",
        ],
      },
      {
        heading: "6. Destinataires",
        body: ["Les données peuvent être transmises uniquement aux partenaires nécessaires à l'exécution du service :"],
        list: ["Prestataires de paiement", "Transporteurs", "Hébergeur du site", "Prestataires techniques"],
      },
      {
        heading: "7. Droits des utilisateurs",
        body: ["Conformément au RGPD, chaque utilisateur dispose des droits suivants :"],
        list: ["Accès", "Rectification", "Effacement", "Limitation du traitement", "Opposition", "Portabilité"],
        footer: `Toute demande peut être adressée à : ${BRAND.email}.`,
      },
      {
        heading: "8. Cookies",
        body: [
          "Le site utilise des cookies nécessaires à son fonctionnement ainsi que des cookies de mesure d'audience et publicitaires. L'utilisateur peut modifier ses préférences à tout moment via le bandeau de gestion des cookies.",
        ],
      },
    ],
  },

  cgv: {
    slug: "cgv",
    title: "Conditions Générales de Vente",
    intro: "CGV et politique de retour applicables aux achats sur French Curl Vibes.",
    sections: [
      {
        heading: "Article 1 – Objet",
        body: [
          `Les présentes CGV régissent les ventes de mèches French Curl réalisées sur le site French Curl Vibes exploité par ${BRAND.legalName}.`,
        ],
      },
      {
        heading: "Article 2 – Produits",
        body: [
          "Les produits proposés sont décrits avec la plus grande précision possible. Les photographies sont présentées à titre illustratif et peuvent présenter de légères différences avec le produit livré.",
        ],
      },
      {
        heading: "Article 3 – Prix",
        body: [
          "Les prix sont indiqués en euros TTC.",
          `${BRAND.legalName} se réserve le droit de modifier ses prix à tout moment. Les produits sont facturés au tarif en vigueur lors de la validation de la commande.`,
        ],
      },
      {
        heading: "Article 4 – Commande",
        body: [
          "Toute commande validée vaut acceptation des présentes CGV.",
          `${BRAND.legalName} se réserve le droit de refuser ou d'annuler toute commande en cas de litige existant avec le client.`,
        ],
      },
      {
        heading: "Article 5 – Paiement",
        body: [
          "Le paiement est exigible immédiatement lors de la commande.",
          "Les moyens de paiement acceptés sont ceux affichés sur le site au moment de l'achat.",
        ],
      },
      {
        heading: "Article 6 – Livraison",
        body: [
          "Les produits sont livrés dans les pays de l'Union Européenne.",
          "Les délais de livraison sont indiqués lors de la commande et peuvent varier selon la destination.",
          `${BRAND.legalName} ne pourra être tenue responsable des retards imputables aux transporteurs.`,
        ],
      },
      {
        heading: "Article 7 – Droit de rétractation",
        body: [
          "Conformément aux articles L221-18 et suivants du Code de la consommation, le client dispose d'un délai de quatorze (14) jours calendaires à compter de la réception de la commande pour exercer son droit de rétractation.",
          `Le client doit notifier sa décision par e-mail à : ${BRAND.email}.`,
        ],
      },
      {
        heading: "Article 8 – Conditions de retour",
        body: ["Pour être accepté :"],
        list: [
          "Le produit doit être neuf.",
          "Le produit ne doit pas avoir été porté, utilisé, coiffé ou modifié.",
          "L'emballage d'origine doit être intact.",
          "Les scellés éventuels doivent être conservés.",
        ],
        footer: "Les frais de retour sont à la charge du client sauf erreur de préparation ou produit défectueux.",
      },
      {
        heading: "Article 9 – Remboursement",
        body: [
          "Après réception et vérification du produit retourné, le remboursement sera effectué dans un délai maximum de quatorze (14) jours via le moyen de paiement utilisé lors de l'achat.",
        ],
      },
      {
        heading: "Article 10 – Produits défectueux",
        body: [
          "En cas de produit défectueux ou non conforme, le client doit contacter le service client dans les 48 heures suivant la réception de la commande en joignant des photographies justificatives.",
        ],
      },
      {
        heading: "Article 11 – Garantie légale",
        body: [
          "Les produits bénéficient des garanties légales de conformité et des vices cachés prévues par la législation française.",
        ],
      },
      {
        heading: "Article 12 – Droit applicable",
        body: [
          "Les présentes CGV sont soumises au droit français.",
          "Tout litige sera soumis aux juridictions françaises compétentes.",
        ],
      },
    ],
  },

  entretien: {
    slug: "entretien",
    title: "Guide d'entretien",
    intro: "Comment préserver la beauté, la souplesse et la durée de vie de vos mèches French Curl.",
    sections: [
      {
        heading: "Avant la pose",
        list: [
          "Déballez délicatement les mèches.",
          "Séparez les brins avec précaution afin d'éviter les nœuds.",
          "Évitez de tirer excessivement sur les boucles.",
        ],
      },
      {
        heading: "Entretien quotidien",
        list: [
          "Séparez délicatement les boucles avec les doigts.",
          "Évitez l'utilisation de peignes fins ou de brosses.",
          "Attachez les cheveux en chignon ou en tresse souple pour dormir.",
          "Utilisez un bonnet ou une taie d'oreiller en satin pour préserver les boucles.",
        ],
      },
      {
        heading: "Hydratation",
        body: ["Pour conserver l'aspect naturel des boucles :"],
        list: [
          "Vaporisez légèrement de l'eau ou un spray hydratant adapté.",
          "Utilisez une mousse coiffante légère si nécessaire.",
          "Évitez les produits trop gras qui peuvent alourdir les boucles.",
        ],
      },
      {
        heading: "Lavage",
        list: [
          "Lavez délicatement à l'eau tiède.",
          "Utilisez un shampoing doux sans sulfate.",
          "Rincez soigneusement.",
          "Laissez sécher naturellement à l'air libre.",
        ],
      },
      {
        heading: "À éviter",
        list: [
          "Chaleur excessive.",
          "Lisseurs ou fers à boucler à haute température.",
          "Brossage agressif.",
          "Produits contenant de l'alcool en forte concentration.",
        ],
      },
      {
        heading: "Durée de vie",
        body: [
          "Avec un entretien approprié, les coiffures French Curl peuvent conserver un aspect esthétique pendant plusieurs semaines selon l'utilisation et les habitudes de soin.",
          `Pour toute question, notre équipe reste à votre disposition à l'adresse : ${BRAND.partnersEmail}.`,
          "Merci de votre confiance. — L'équipe French Curl Vibes",
        ],
      },
    ],
  },

  faqDetailed: {
    slug: "faq-detaillee",
    title: "FAQ détaillée",
    intro: "Toutes les réponses à vos questions sur French Curl Vibes.",
    sections: [
      {
        heading: "Commandes",
        qa: [
          { q: "Comment passer commande ?", a: "Sélectionnez vos produits, ajoutez-les au panier puis suivez les étapes de paiement sécurisées." },
          { q: "Puis-je modifier ma commande ?", a: "Toute demande de modification doit être adressée rapidement après l'achat. Une fois la commande expédiée, aucune modification ne pourra être garantie." },
        ],
      },
      {
        heading: "Livraison",
        qa: [
          { q: "Dans quels pays livrez-vous ?", a: "Nous livrons dans l'ensemble des pays de l'Union Européenne." },
          { q: "Quels sont les délais de livraison ?", a: "Les délais varient selon la destination et le transporteur sélectionné. Une estimation est affichée lors de la commande." },
          { q: "Comment suivre mon colis ?", a: "Dès l'expédition, un numéro de suivi vous est communiqué par e-mail." },
        ],
      },
      {
        heading: "Paiement",
        qa: [
          { q: "Quels moyens de paiement acceptez-vous ?", a: "Nous acceptons les moyens de paiement affichés sur le site lors de la validation de la commande." },
          { q: "Le paiement est-il sécurisé ?", a: "Oui. Toutes les transactions sont traitées via des plateformes de paiement sécurisées (Stripe, Apple Pay, Google Pay)." },
        ],
      },
      {
        heading: "Retours et remboursements",
        qa: [
          { q: "Puis-je retourner un produit ?", a: "Oui. Vous disposez d'un délai légal de 14 jours à compter de la réception de votre commande." },
          { q: "Quelles sont les conditions de retour ?", a: "Les produits doivent être non utilisés, non portés, dans leur emballage d'origine et en parfait état de revente." },
          { q: "Qui paie les frais de retour ?", a: "Sauf erreur de notre part ou produit défectueux, les frais de retour sont à la charge du client." },
          { q: "Quand serai-je remboursé(e) ?", a: "Le remboursement est effectué dans un délai maximum de 14 jours après réception et validation du retour." },
        ],
      },
      {
        heading: "Produits",
        qa: [
          { q: "Les couleurs correspondent-elles exactement aux photos ?", a: "Nous faisons notre maximum pour présenter fidèlement les produits. De légères variations peuvent toutefois apparaître selon les écrans utilisés." },
          { q: "Comment choisir la bonne longueur ?", a: "Notre French Curl est proposée en longueur unique 24\". Pour toute question, contactez notre service client." },
        ],
      },
      {
        heading: "Service client",
        qa: [
          { q: "Comment nous contacter ?", a: `Par e-mail : ${BRAND.email}. Notre équipe s'engage à répondre dans les meilleurs délais.` },
        ],
      },
    ],
  },
};

// Partners program tiers
export const PARTNER_TIERS = [
  {
    id: "bronze",
    label: "Partenaire Bronze",
    emoji: "🥉",
    accent: "#A36A4A",
    tagline: "Pour les coiffeuses indépendantes et les professionnels qui débutent leur collaboration avec French Curl Vibes.",
    condition: "À partir de 5 paquets commandés par mois",
    advantages: [
      "10 % de remise professionnelle",
      "Accès aux nouveautés en avant-première",
      "Support commercial dédié",
      "Accès au groupe partenaires French Curl Vibes",
    ],
  },
  {
    id: "silver",
    label: "Partenaire Silver",
    emoji: "🥈",
    accent: "#7E8893",
    tagline: "Pour les professionnels qui utilisent régulièrement les produits French Curl Vibes auprès de leur clientèle.",
    condition: "À partir de 11 paquets commandés par mois",
    advantages: [
      "15 % de remise professionnelle",
      "Accès prioritaire aux réassorts",
      "Mise en avant occasionnelle sur nos réseaux sociaux",
      "Support prioritaire",
      "Accès aux opérations promotionnelles réservées aux partenaires",
    ],
  },
  {
    id: "gold",
    label: "Partenaire Gold",
    emoji: "🥇",
    accent: "#C9A66B",
    tagline: "Pour les salons et coiffeuses à forte activité souhaitant développer un véritable partenariat avec la marque.",
    condition: "À partir de 30 paquets commandés par mois",
    advantages: [
      "20 % de remise professionnelle",
      "Mise en avant régulière sur nos réseaux sociaux",
      "Référencement sur notre annuaire de partenaires",
      "Accès privilégié aux nouveautés et éditions limitées",
      "Accompagnement personnalisé",
      "Priorité sur les stocks lors des lancements et réassorts",
    ],
  },
  {
    id: "ambassadrice",
    label: "Ambassadrice French Curl Vibes",
    emoji: "⭐",
    accent: "#C58C85",
    tagline: "Programme accessible sur sélection — réservé aux coiffeuses et créatrices de contenu qui contribuent activement à la visibilité de la marque.",
    condition: "Sur invitation et sélection",
    advantages: [
      "Conditions tarifaires privilégiées",
      "Collaboration sur les campagnes marketing",
      "Mise en avant renforcée sur Instagram et le site internet",
      "Participation aux lancements de produits",
      "Opportunités de partenariat rémunéré selon les campagnes",
    ],
  },
];

export const PARTNER_BENEFITS = [
  { icon: "tag", title: "Tarifs professionnels préférentiels", text: "Bénéficiez de remises exclusives sur l'ensemble de notre gamme de mèches French Curl." },
  { icon: "sparkles", title: "Produits de qualité premium", text: "Offrez à vos clientes des mèches sélectionnées pour leur qualité, leur légèreté et leur rendu naturel." },
  { icon: "package", title: "Approvisionnement simplifié", text: "Commandez facilement les quantités dont vous avez besoin pour votre activité." },
  { icon: "users", title: "Développement de votre clientèle", text: "Les partenaires sont mis en avant sur nos réseaux sociaux et nos supports de communication." },
  { icon: "headphones", title: "Accompagnement personnalisé", text: "Notre équipe reste disponible pour vous conseiller sur les produits et les nouveautés." },
];
